"use client";

import React from "react";
import { MapPin, Phone, Mail, MessageSquare, Upload, Loader, CircleCheck, CircleAlert } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
function ProposalForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center h-full min-h-[400px] text-center p-8 animate-in fade-in zoom-in duration-500">
        <div className="size-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-6">
          <CircleCheck className="size-8" />
        </div>
        <h3 className="text-2xl font-bold text-foreground mb-2">Solicitação Enviada!</h3>
        <p className="text-muted-foreground max-w-md mb-8">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline">
          Enviar nova solicitação
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {}
        <FormField control={control} name="nome" rules={{
        required: "Nome é obrigatório"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Nome Completo <span className="text-destructive">*</span></FormLabel>
              <FormControl>
                <Input placeholder="Maria Silva" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="email" rules={{
        required: "E-mail é obrigatório",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "E-mail inválido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>E-mail <span className="text-destructive">*</span></FormLabel>
              <FormControl>
                <Input type="email" placeholder="maria@example.com" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {}
        <FormField control={control} name="telefone" rules={{
        required: "Telefone é obrigatório"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Telefone <span className="text-destructive">*</span></FormLabel>
              <FormControl>
                <Input type="tel" placeholder="(11) 98765-4321" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="empresa" rules={{
        required: "Nome da empresa é obrigatório"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Empresa / Organização <span className="text-destructive">*</span></FormLabel>
              <FormControl>
                <Input placeholder="Nome da empresa" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      {}
      <FormField control={control} name="setor" rules={{
      required: "Selecione um setor"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Setor de Atuação <span className="text-destructive">*</span></FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger><span data-slot="select-value" data-ast-id="f:/src/pages/Contact/sections/SolicitacaoDeProposta.tsx|sig:cjrs24" data-ast-start="4143" data-ast-end="4190" style={{
              pointerEvents: 'none'
            }}>Indústria / Processos</span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-chevron-down size-4 opacity-50" aria-hidden="true"><path d="m6 9 6 6 6-6"></path></svg></SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="Saúde / Médico-hospitalar">Saúde / Médico-hospitalar</SelectItem>
                <SelectItem value="Salas limpas / Farmacêutica">Salas limpas / Farmacêutica</SelectItem>
                <SelectItem value="Indústria / Processos">Indústria / Processos</SelectItem>
                <SelectItem value="Telecom / Datacenter">Telecom / Datacenter</SelectItem>
                <SelectItem value="Outro">Outro</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>} />

      {}
      <FormField control={control} name="descricao_projeto" rules={{
      required: "Descrição do projeto é obrigatória"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Descrição do Projeto <span className="text-destructive">*</span></FormLabel>
            <FormControl>
              <Textarea placeholder="Descreva brevemente as necessidades e requisitos técnicos..." className="min-h-[120px]" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {}
        <FormField control={control} name="faixa_orcamento" render={({
        field
      }) => <FormItem>
              <FormLabel>Faixa de Orçamento</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Selecione a faixa" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="Até R$ 50.000">Até R$ 50.000</SelectItem>
                  <SelectItem value="R$ 50.001 - R$ 200.000">R$ 50.001 - R$ 200.000</SelectItem>
                  <SelectItem value="R$ 200.001 - R$ 500.000">R$ 200.001 - R$ 500.000</SelectItem>
                  <SelectItem value="Acima de R$ 500.000">Acima de R$ 500.000</SelectItem>
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="anexo" render={({
        field: {
          value,
          onChange,
          ...fieldProps
        }
      }) => <FormItem>
              <FormLabel>Anexos (opcional)</FormLabel>
              <FormControl>
                <div className="relative">
                  <Input type="file" className="cursor-pointer file:cursor-pointer file:text-primary file:font-medium" onChange={e => {
              onChange(e.target.files?.[0]);
            }} {...fieldProps} />
                  <Upload className="absolute right-3 top-2.5 size-4 text-muted-foreground pointer-events-none" />
                </div>
              </FormControl>
              <FormDescription>PDF, DOC, até 5MB</FormDescription>
              <FormMessage />
            </FormItem>} />
      </div>

      {}
      <FormField control={control} name="metodo_contato" rules={{
      required: "Selecione um método de contato"
    }} render={({
      field
    }) => <FormItem className="space-y-3">
            <FormLabel>Método Preferencial de Contato <span className="text-destructive">*</span></FormLabel>
            <FormControl>
              <div className="flex flex-row gap-6">
                {["E-mail", "Telefone"].map(option => <label key={option} className="flex items-center space-x-2 cursor-pointer group">
                    <div className="relative flex items-center">
                      <input type="radio" className="peer sr-only" value={option} checked={field.value === option} onChange={field.onChange} />
                      <div className="size-4 rounded-full border border-input bg-background ring-offset-background peer-checked:border-primary peer-checked:bg-primary peer-focus-visible:ring-2 peer-focus-visible:ring-ring peer-focus-visible:ring-offset-2 transition-all">
                        <div className="absolute inset-0 flex items-center justify-center">
                          <div className="size-2 rounded-full bg-primary-foreground scale-0 peer-checked:scale-100 transition-transform" />
                        </div>
                      </div>
                    </div>
                    <span className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 group-hover:text-primary transition-colors">
                      {option}
                    </span>
                  </label>)}
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-lg flex items-start gap-3">
          <CircleAlert className="size-5 text-destructive shrink-0 mt-0.5" />
          <p className="text-sm text-destructive font-medium">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto min-w-[200px] h-12 text-base">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-5" />
            Enviando solicitação...
          </> : 'Solicitar Proposta'}
      </Button>
    </Form>;
}
export default function SolicitacaoDeProposta() {
  return <section id="solicitação-de-proposta" className="relative py-20 lg:py-28 bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" aria-hidden="true">
        <svg className="w-full h-full" width="100%" height="100%">
          <defs>
            <pattern id="grid-pattern" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M0 40L40 0H20L0 20M40 40V20L20 40" stroke="currentColor" strokeWidth="1" fill="none" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid-pattern)" />
        </svg>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          
          {}
          <div className="w-full lg:w-7/12 xl:w-2/3">
            <div className="mb-8">
              <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-4">
                Solicitação de Proposta
              </h2>
              <p className="text-lg text-muted-foreground">
                Preencha o formulário abaixo para que nossa equipe de engenharia analise sua necessidade e entre em contato com uma solução personalizada.
              </p>
            </div>

            <Card className="border-border/50 shadow-2xs bg-card/80 backdrop-blur-sm">
              <CardContent className="p-6 md:p-8">
                <FormProvider formId="solicitacao_proposta_contact" sectionName="solicitacao-proposta" defaultValues={{
                nome: "",
                email: "",
                telefone: "",
                empresa: "",
                setor: "",
                descricao_projeto: "",
                faixa_orcamento: "",
                metodo_contato: "E-mail",
                anexo: undefined
              }} validationRules={{
                nome: {
                  required: true
                },
                email: {
                  required: true,
                  pattern: "email"
                },
                telefone: {
                  required: true
                },
                empresa: {
                  required: true
                },
                setor: {
                  required: true
                },
                descricao_projeto: {
                  required: true
                },
                metodo_contato: {
                  required: true
                }
              }} submitText="Solicitar Proposta" successMessage="Recebemos sua solicitação com sucesso. Nossa equipe técnica entrará em contato em breve.">
                  <ProposalForm />
                </FormProvider>
              </CardContent>
            </Card>
          </div>

          {}
          <div className="w-full lg:w-5/12 xl:w-1/3 flex flex-col gap-8">
            
            {}
            <div className="grid gap-6">
              <Card className="bg-primary text-primary-foreground border-none shadow-2xs overflow-hidden relative">
                <div className="absolute top-0 right-0 p-4 opacity-10">
                  <MessageSquare className="size-24" />
                </div>
                <CardHeader>
                  <CardTitle className="text-xl flex items-center gap-2">
                    <MessageSquare className="size-5" />
                    Fale com a Engenharia
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 relative z-10">
                  <p className="text-primary-foreground/90">
                    Precisa de uma resposta rápida ou suporte técnico imediato?
                  </p>
                  <Button asChild variant="secondary" className="w-full font-semibold shadow-none hover:bg-secondary/90">
                    <Link to="https://wa.me/5511999999999" newTab className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive text-secondary-foreground h-9 px-4 py-2 has-[>svg]:px-3 w-full font-semibold shadow-none !bg-[hsl(210,40%,98%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-secondary/90">
                      <MessageSquare className="size-4 mr-2" />
                      Conversar no WhatsApp
                    </Link>
                  </Button>
                </CardContent>
              </Card>

              <Card className="bg-card border-border shadow-2xs">
                <CardContent className="p-6 space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="bg-primary/10 p-3 rounded-lg shrink-0">
                      <MapPin className="size-6 text-primary" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground mb-1">Endereço</h4>
                      <p className="text-muted-foreground text-sm leading-relaxed">Av. Getulio Vargas 470 - Ourinhos - SP<br />Atendimento em todo o território nacional.</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="bg-primary/10 p-3 rounded-lg shrink-0">
                      <Mail className="size-6 text-primary" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground mb-1">E-mail</h4>
                      <p className="text-muted-foreground text-sm">
                        <Link to="mailto:contato@doctorice.com.br" className="hover:text-primary transition-colors">
                          contato@doctorice.com.br
                        </Link>
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="bg-primary/10 p-3 rounded-lg shrink-0">
                      <Phone className="size-6 text-primary" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground mb-1">Telefone</h4>
                      <p className="text-muted-foreground text-sm">
                        <Link to="tel:+5511999999999" className="hover:text-primary transition-colors">(14) 3324-5757</Link>
                      </p>
                      <p className="text-xs text-muted-foreground mt-1">
                        Seg-Sex: 8h às 18h
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            {}
            <div className="rounded-xl overflow-hidden border border-border shadow-2xs h-64 lg:h-auto lg:flex-1 min-h-[250px] relative bg-muted">
              <img src="https://doctorice.10web.cloud/wp-content/uploads/2026/03/WhatsApp-Image-2026-03-11-at-18.01.51.jpeg" alt="Localização Doctorice" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6">
                <div className="text-white">
                  <p className="font-semibold text-sm flex items-center gap-2">
                    <MapPin className="size-4" />
                    Sede Administrativa & Fabril
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>;
}